"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var IRIS_READ_ENDPOINT = 'iris-read/v1/app';

var IrisAPI =
/*#__PURE__*/
function () {
  function IrisAPI() {
    (0, _classCallCheck2.default)(this, IrisAPI);
  }

  (0, _createClass2.default)(IrisAPI, null, [{
    key: "getFields",
    value: function getFields(hubFields, hubUserFields) {
      return _apiClient.default.get(IRIS_READ_ENDPOINT, {
        query: {
          hubField: hubFields,
          hubUserField: hubUserFields
        }
      });
    }
  }]);
  return IrisAPI;
}();

exports.default = IrisAPI;
module.exports = exports.default;